import MigrationPending from '@/components/ui/MigrationPending'

export default function OrdersToPlaceReport() {
  return <MigrationPending title="Orders to Place" subtitle="Report — migration to new stack pending" />
}

OrdersToPlaceReport.layout = MigrationPending.layout
